import { Box, Divider } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { useEffect } from 'react';

import ListSingleForm from '../../common/ListSingleForm/ListSingleForm';
import {
  deleteAreaRequest,
  getAreas,
  loadAreasRequest,
} from '../../../redux/areasRedux';
import AddAreaForm from '../../features/AddAreaForm/AddAreaForm';
import { useTranslation } from 'react-i18next';
const AddArea = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const areas = useSelector((state) => getAreas(state));

  const handleSubmit = async (id) => {
    await dispatch(deleteAreaRequest(id));
  };

  useEffect(() => {
    const start = async () => {
      await dispatch(loadAreasRequest());
    };

    start();
  }, [dispatch]);

  return (
    <Box>
      <AddAreaForm />
      <Divider sx={{ mt: 5 }} />
      {areas.length > 0 && (
        <ListSingleForm
          action={handleSubmit}
          props={areas}
          text={t('pz05.incompatibilities.area.description')}
          link="edit-area"
        />
      )}
    </Box>
  );
};

export default AddArea;
